const FINRA_PRODUCTS = [
  {
    uuid: '77711841-24ae-4eab-a208-b381e767916e',
    shortName: 'SIE',
    price: 74,
    slug: 'finra-sie',
  },
  {
    uuid: 'b8792837-fa75-4b3b-86f9-275c59219c6f',
    shortName: 'Series 6',
    price: 99,
    slug: 'finra-series-6',
  },
  {
    uuid: '6a6e2b55-1287-4ee3-90e7-b06eb0b8f8ce',
    shortName: 'Series 7',
    price: 149,
    slug: 'finra-series-7',
  },
  {
    uuid: '114756d6-4df0-4ee2-8e6a-de3858af256d',
    shortName: 'Series 63',
    price: 59,
    slug: 'finra-series-63',
  },
  {
    uuid: '4f6ef5d9-23e7-4bc6-8058-461dbfe8eda0',
    shortName: 'Series 65',
    price: 199,
    slug: 'finra-series-65',
  },
  {
    uuid: 'b072c490-f4da-47b4-b67a-4330e7315a33',
    shortName: 'Series 66',
    price: 199,
    slug: 'finra-series-66',
  },
  {
    uuid: 'fe786e9e-8f10-442c-92fc-dde7052b9b8c',
    shortName: 'Bundle: SIE + S7',
    price: 199,
    slug: 'finra-bundle-sie-s7',
  },
  {
    uuid: 'e1752e3e-4fc3-4e28-8b50-da3bd954a0dc',
    shortName: 'Bundle: All courses',
    price: 274,
    slug: 'finra-everything',
  },
];

export default FINRA_PRODUCTS;
